<template>
    <v-app>
        <div class="Auth">
            <Overlay/>
            <div class="Auth__logo">
                <img src="@/assets/img/SwyftLandingLogo.png" alt=""/>
            </div>
            <router-view/>
        </div>
    </v-app>

</template>
<script>
import Overlay from '@/components/Overlay';
export default {
    components: { Overlay }
};
</script>
<style lang="scss">
.Auth {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    min-height: 100vh;
    justify-content: center !important;
    align-content: center !important;
    align-items: center !important;
    padding: 24px !important;
    background: rgb(123, 44, 136);
    background: linear-gradient(145deg, rgba(123, 44, 136, 1) 0%, rgba(212, 33, 108, 1) 100%);
}

.Auth__logo {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    height: auto;
    margin-bottom: 24px !important;

    img {
        max-width: 100px !important;
        margin: 0 !important;

        @media (min-width: 600px) {
            max-width: 180px !important;
        }
    }
}

.Auth__secondary-actions {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    flex: 0 0 100%;
    width: 100%;
}
</style>
